export const BRAND = {
  build: '#2B3DFF',
  hot: '#FF2D6F',
  solar: '#FF7A00',
  volt: '#C6FF00',
  ink: '#0B0B12',
  paper: '#FBFAF6',
} as const;

export const INK_RAMP = {
  70: '#4A4A57',
  40: '#8C8C99',
  15: '#D9D9E0',
  7: '#EDEDF2',
} as const;

export const ON_BRAND = {
  build: BRAND.paper,
  hot: BRAND.paper,
  solar: BRAND.ink,
  volt: BRAND.ink,
} as const;

export const CHANNEL = {
  store: BRAND.build,
  creator: BRAND.hot,
  countdown: BRAND.solar,
  live: BRAND.volt,
} as const;

export type Channel = keyof typeof CHANNEL;

export const ACCENT = BRAND.build;

export const GROUND = '#0B0B1A';

export const FONTS = {
  display: 'Fredoka',
  text: 'Archivo',
  mono: 'Martian Mono',
} as const;
